import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setCredentials, logout } from '../../redux/slices/authSlice';
import AuthAPI from '../../api/auth';

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  // Define public routes that don't require authentication
  const publicRoutes = ['/login', '/external', '/external/success'];

  const verifyAuth = useCallback(async () => {
    try {
      const response = await AuthAPI.verify();
    //   console.log('Verify response:', response);
      dispatch(setCredentials(response));
      setIsVerifying(false);
      
      // If we're on login page but verified, redirect to dashboard
      if (location.pathname === '/login' && response.user) {
        navigate('/dashboard');
      }
    } catch (error) {
    //   console.error('Verify error:', error);
      dispatch(logout());
      setIsVerifying(false);
      // Only redirect to login if we're not on a public route
      if (!publicRoutes.includes(location.pathname)) {
        navigate('/login');
      }
    }
  }, [dispatch, location.pathname, navigate]);

  useEffect(() => {
    if (!isAuthenticated || location.pathname === '/') {
      verifyAuth();
    } else {
      setIsVerifying(false);
    }
  }, [location.pathname, isAuthenticated, verifyAuth]);

  // Show loading state while verifying, but not on public routes
  if (isVerifying && !publicRoutes.includes(location.pathname)) {
    return <div>Loading...</div>; // You can replace this with a proper loading component
  }

  return children;
};

export default AuthProvider; 